import { CamelToSnakeCase } from "types/index";
import { BlockSubTypes, BlockTypes } from "./helpers/blocks";
import { Conditions } from "modules/Conditions/conditions";
import { SupportingInfo } from "modules/SupportingInfo/supportingInfo";
import { FormattingRule, PositionInstructions } from "@coolset/cs-ui";

export namespace SurveyBlocks {
  export interface Block {
    id: number;
    objectId: number;
    order: number;
    isRequired: boolean;
    previewDisplayType: string;
    contentType: BlockTypes;
    contentObject: Partial<BlockContent>;
    conditions: Conditions.Condition[];
    relatedSupportingInformation: SupportingInfo.RelatedSupportingInfo[];
    surveyId: number | string;
    survey?: {
      id: number;
      objectId: number;
      title: string;
      type: BlockSubTypes;
    };
  }

  export interface BlockContent {
    fieldId: string;
    title: string;
    subtitle: string;
    tooltip: string;
    options: string[];
    isAllowDecimalPlaces: boolean;
    rangeMin: number;
    rangeMax: number;
    layout: string;
    expression: string;
    maxRows?: number;
    maxColumns?: number;
    type?: BlockSubType;
    formattingInstructions?: FormattingRule[];
    positionInstructions?: PositionInstructions;
  }

  export type BlockSubType = 'chart' | 'table';

  export enum BlockContentCharLimit {
    expression = 255,
    fieldId = 125,
    subtitle = 380,
    title = 380,
    tooltip = 255,
  }

  export enum BlockContentRowCount {
    expression = 2,
    fieldId = 1,
    subtitle = 1,
    title = 1,
    tooltip = 1,
  }


  export type BlockApi = CamelToSnakeCase<Block>;

  export type CreateBlockParams = {
    name: string;
    contentType: string;
    order: number;
  };
}
